import { ReduxRootState } from "../types/redux-store";
export const COLLAB_ACTIVE_CHANNELS = "colActiveChannels" as const;

export const getComments = (state: ReduxRootState, channelId: string) =>
  state.entities[COLLAB_ACTIVE_CHANNELS][channelId]?.comments || {};

export const isRequestingCommentsSelector = (
  state: ReduxRootState,
  channelId: string
) =>
  state.entities[COLLAB_ACTIVE_CHANNELS][channelId]?.isRequestingComments ||
  false;
